import logger from "../logger/logger";

const sendMessageToReactNative = (message: any) => {
  try {
    const messageAsJson = JSON.stringify(message);
    if (window && (window as any).ReactNativeWebView && (window as any).ReactNativeWebView.postMessage) {
      (window as any).ReactNativeWebView.postMessage(messageAsJson);
    }
  } catch (error) {
    logger.logError(error);
  }
};

const initReactNativeBridgeListener = (type: string, listener: EventListener): boolean => {
  try {
    if (window && (window as any).ReactNativeWebView) {
      window.addEventListener(type, listener, false);
      return true;
    }
    return false;
  } catch (error) {
    logger.logError(error);
    return false;
  }
};

const removeReactNativeBridgeListener = (type: string, listener: EventListener): boolean => {
  try {
    if (window && (window as any).ReactNativeWebView) {
      window.removeEventListener(type, listener, false);
      return true;
    }
    return false;
  } catch (error) {
    logger.logError(error);
    return false;
  }
};

const startAppReview = (useNativeOnly = false) => {
  const message = {
    action: Action.StartAppReview,
    data: { startAppReviewRequest: { useNativeOnly: useNativeOnly } },
  };
  sendMessageToReactNative(message);
};

export enum Action {
  WalletIdRequest = "WALLET_ID_REQUEST",
  WalletIdResponse = "WALLET_ID_RESPONSE",
  TokenStatusRefresh = "TOKEN_STATUS_REFRESH",
  TokenStatusRequest = "TOKEN_STATUS_REQUEST",
  TokenStatusResponse = "TOKEN_STATUS_RESPONSE",
  PushProvisionRequest = "PUSH_PROVISION_REQUEST",
  PushProvisionResponse = "PUSH_PROVISION_RESPONSE",
  CreateWalletRequest = "CREATE_WALLET_REQUEST",
  CreateWalletResponse = "CREATE_WALLET_RESPONSE",
  GetPassesRequest = "GET_PASSES_REQUEST",
  GetPassesResponse = "GET_PASSES_RESPONSE",
  PushProvisionApplePayRequest = "PUSH_PROVISION_APPLE_PAY_REQUEST",
  PushProvisionApplePayResponse = "PUSH_PROVISION_APPLE_PAY_RESPONSE",
  GetBiometricSettingsRequest = "GET_BIOMETRIC_SETTINGS_REQUEST",
  GetBiometricSettingsResponse = "GET_BIOMETRIC_SETTINGS_RESPONSE",
  OpenBiometricSettingsRequest = "OPEN_BIOMETRIC_SETTINGS_REQUEST",
  OpenBiometricSettingsResponse = "OPEN_BIOMETRIC_SETTINGS_RESPONSE",
  ChangePinRequest = "CHANGE_PIN_REQUEST",
  ChangePinResponse = "CHANGE_PIN_RESPONSE",
  KeepAlive = "KEEPALIVE",
  StartIdentificationRequest = "START_IDENTITY_REQUEST",
  StartAppReview = "START_APP_REVIEW_REQUEST",
  GetCookieConsentRequest = "GET_COOKIE_CONSENT_REQUEST",
  GetCookieConsentResponse = "GET_COOKIE_CONSENT_RESPONSE",
  SetCookieConsentRequest = "SET_COOKIE_CONSENT_REQUEST",
  SamsungPayInfoRequest = "SPAY_INFO_REQUEST",
  SamsungPayInfoResponse = "SPAY_INFO_RESPONSE",
  SamsungActivateRequest = "SPAY_ACTIVATE_REQUEST",
  SamsungUpdatePageRequest = "SPAY_UPDATE_PAGE_REQUEST",
  SamsungPushProvisionRequest = "SPAY_PUSH_PROVISION_REQUEST",
  SamsungPushProvisionResponse = "SPAY_PUSH_PROVISION_RESPONSE",
  ForceLogin = "FORCE_LOGIN",
  ThemeChanged = "ThemeChanged",
}

export interface Event {
  action: Action;
  data?: any;
}

export { sendMessageToReactNative, initReactNativeBridgeListener, removeReactNativeBridgeListener, startAppReview };
